import { GitHubService } from '../services/GitHubService';
import { alternateAudioRepoPaths, mimeForAudioPath } from '../utils/itemAudio';
import { withoutGitBusyOverlay } from '../utils/gitBusy';

/** Blob URL cache for item audio clips in the file view. */
export class AppAudioCache {
  private readonly urls = new Map<string, string>();

  revokeAll(): void {
    for (const url of this.urls.values()) URL.revokeObjectURL(url);
    this.urls.clear();
  }

  async getPlaybackUrl(
    github: GitHubService,
    repoPath: string,
    bustCache = false,
    mdPath?: string
  ): Promise<string> {
    const cacheKey = `audio:v1:${mdPath ?? ''}:${repoPath}`;
    if (bustCache) {
      const old = this.urls.get(cacheKey);
      if (old) URL.revokeObjectURL(old);
      this.urls.delete(cacheKey);
    }
    const cached = this.urls.get(cacheKey);
    if (cached) return cached;

    const pathsToTry = alternateAudioRepoPaths(repoPath, mdPath);
    let lastErr: unknown;
    for (const path of pathsToTry) {
      try {
        const { bytes } = await withoutGitBusyOverlay(() => github.readBinary(path));
        const mime = mimeForAudioPath(path);
        const blob = new Blob([new Uint8Array(bytes)], { type: mime });
        const url = URL.createObjectURL(blob);
        this.urls.set(cacheKey, url);
        return url;
      } catch (err) {
        lastErr = err;
      }
    }
    throw lastErr instanceof Error ? lastErr : new Error('Could not load audio');
  }
}
